// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1922":"2a7ca6eb","3337":"2a7ca6eb","3733":"518f50ea","5149":"13febca8","5195":"2a7ca6eb"}[chunkId] + ".chunk.css";
};